(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('OperazioneDeleteController',OperazioneDeleteController);

    OperazioneDeleteController.$inject = ['$uibModalInstance', 'entity', 'Operazione'];

    function OperazioneDeleteController($uibModalInstance, entity, Operazione) {
        var vm = this;

        vm.operazione = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Operazione.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
